import React from 'react';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { buttonStyle, useStyles } from './styles';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import Button from '../Button/Button';
import { LANG_TEXT } from '../../constants/language';

function CustomDialog({ id, open, onClose, onRedirect }: { id: string; open: boolean; onClose: () => void; onRedirect: () => void }) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      <DialogTitle className={classes.dialog_background} id="alert_new_service_request" style={{ textAlign: 'center' }}>
        <Box className={classes.title}>
          {t(LANG_TEXT.POPUP_REQUEST)} {id}
        </Box>
      </DialogTitle>
      <DialogContent className={classes.dialog_background} style={{ textAlign: 'center' }}>
        <Box
          style={{
            display: 'inline-flex',
            flexFlow: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          className={classes.dialog_background}
        >
          <NotificationsActiveIcon style={{ fontSize: '50px', color: '#ffffff' }} />
        </Box>
      </DialogContent>
      <DialogActions className={classes.dialog_background} style={{ justifyContent: 'center' }}>
        <Box>
          <Button
            id="title"
            fullWidth={false}
            title={t(LANG_TEXT.COMMON_YES)}
            buttonStyle={buttonStyle}
            sxTextStyle={{ fontSize: '14px', fontWeight: '600', lineHeight: '20px', color: 'var(--Primary-700, #ffffff)' }}
            onClick={onRedirect}
          />
        </Box>
      </DialogActions>
    </Dialog>
  );
}

export default CustomDialog;
